import React from 'react';
import logo from "../assets/Logo/Austin logo light.png";

function Footer() {
  return (
    <footer className="bg-[#1A3C34] text-white border-t border-gray-200 px-6 py-10">
      <div className="max-w-7xl mx-auto flex flex-col items-center justify-center text-center gap-6">
        
        {/* Logo */}
        <a href="/" aria-label="Home">
          <img src={logo} alt="ATX Plant Rescue Logo" className="h-28 w-auto mx-auto" />
        </a>

        {/* Copyright */}
        <div className="text-md text-white">
          © 2025 DBA Austin Plant Rescue — All Rights Reserved
        </div>

      </div>
    </footer>
  );
}

export default Footer;
